import { Component, OnInit, Input, Inject } from '@angular/core';
@Component({
  selector: 'nns-item-note',
  styles: [`
    :host {
      display: block;
      padding:8px 10px;
      width:33%;
      box-sizing:border-box;
    }
    .nns-item-note-link {
      box-sizing:border-box;
      color:rgba(0,0,0,0.80);
      position:relative;
      display:block;
      transition: 0.3s;
    }
    .nns-item-note-link:hover{
      box-shadow: 0px 1px 16px rgba(192, 205, 216, 0.8);
    }
    .nns-item-note-layer {
      position:absolute;
      left:0;
      top:0;
      width:100%;
      height:100%;
      display:block;
      background:#fff;
      border-radius:4px;
      box-shadow: 0px 3.2px 7.2px rgb(0 0 0 / 6%)
    }
    .nns-item-note-main {
      position:relative;
      z-index:5;
      width:100%;
      height:100%;
      padding:20px;
      box-sizing:border-box;
      overflow:hidden;
      transition:all 0.1s ease-out;
      border-radius:2px;
    }
    .nns-item-note-preview {
      position: relative;
    }
    .nns-item-note-preview img {
      display: block;
      border-radius:4px 4px 0px 0px;
    }
    .nns-item-note-link:hover {color:rgba(0,0,0,0.80);}

    .nns-item-note-meta {
      font-size:12px;
      color:rgba(0,0,0,0.60);
      padding: 13px 0 2px;
    }
    .nns-item-note-meta-date {padding:0 8px 0 0;}
    .nns-item-note-meta-source {
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
    }

    .nns-item-note-title {
      font-size:16px;
      font-weight: bold;
      overflow:hidden;
      text-overflow:inherit;
      line-height:22px;
      letter-spacing: .3px;
      color: #000;
      opacity: .8;
    }

    .nns-item-note-content {
      padding-top: 20px;
      margin:0 0 -12px 0;
    }

    .nns-item-note-img {
      width:100%;
      height:140px;
      background-size:cover !important;
      display:block;
      margin:-4px -12px 0 -12px;
      padding:0 12px;
    }
    .nns-item-note-desc {
      font-size:14px;
      line-height:22px;
      padding-bottom: 12px;
      opacity: .8;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    @media only screen and (max-width: 1024px) {
      :host {width:50%;}
    }

    @media only screen and (max-width: 600px) {
      :host {width:100%;}
    }
  `, `
    :host-context(.nns-theme-night) .nns-item-note-link {
      color:rgba(255,255,255, 0.8);
    }
    :host-context(.nns-theme-night) .nns-item-note-layer {
      background:#292E32;
      box-shadow:4px 4px 38px rgb(19 30 32 / 66%);
    }
    :host-context(.nns-theme-night) .nns-item-note-link:hover {
      color:#fff;
    }
    :host-context(.nns-theme-night) .nns-item-note-link:hover {
      box-shadow: 0px 1px 16px #0C0F11;
    }

    :host-context(.nns-theme-night) .nns-item-note-title {
      color: #FFF
    }
    :host-context(.nns-theme-night) .nns-item-note-meta {
      color:rgba(255,255,255, 0.6);
    }
    :host-context(.nns-theme-night) .nns-item-note-desc {
      color:#fff;
    }
    @media print {
      :host-context(.nns-theme-night) .nns-item-note-title,
      :host-context(.nns-theme-night) .nns-item-note-desc {
        color: #161616;
      }
    }
  `],
  template: `
  <a class="nns-item-note-link" [routerLink]="[urlString]"  title="{{item.title | unescape}}">
    <span class="nns-item-note-layer"></span>
    <span *ngIf="item.previewUrl" class="nns-item-note-preview">
      <img [src]="item.previewUrl" alt="note" style="max-width: 100%">
    </span>
    <span class="nns-item-note-main" flex layout="column">
      <span class="nns-item-note-title" flex="none">
        <span [innerHTML]="item.title"></span>
      </span>
      <span class="nns-item-note-content" *ngIf="item.text && item.text.textShort" flex="auto" layout="row" layout-align="start end">
        <span class="nns-item-note-desc">
          <span [innerHTML]="item.text.textShort"></span>
        </span>
      </span>
      <span
        *ngIf="item.url"
        class="nns-item-note-meta"
        flex="none"
        layout="row"
        layout-align="start center">
        <span class="nns-item-note-meta-source" flex>{{ item.url }}</span>
      </span>
    </span>
  </a>
  `,
})
export class ItemNoteComponent implements OnInit {
  @Input() public item;
  @Input() public share;
  date;
  urlString;
  preview?: {
    width: number;
    height: number;
  };
  constructor(@Inject('isBrowser') public isBrowser: boolean) {}

  ngOnInit() {
    const dateToConvert =  new Date(this.item.dateUpdated * 1000);
    this.date = dateToConvert.toLocaleString();
    const shareInstance = this.share.instance;
    if(this.item.share && this.item.share.passwordRequired) {
      const childShare = this.item.share;
      this.urlString = `/share/${childShare.id}/${childShare.securityKey}`
    } else {
      this.urlString = `/share/${shareInstance.id}/${shareInstance.securityKey}/${this.item.globalId}`;
    }
  }

}
